import api from '.'

export const marketing = {
  contact (data, success, fail) {
    api.unauthenticatedRequest('POST', '/marketing/contact', data, success, fail)
  }

}
